module.exports = __webpack_public_path__ + "img/7.dc1674a7.png";